import { useQueryParam } from 'use-query-params';
export const useVerifySteamStageError = () => {
    const [error] = useQueryParam('error');
    const [code] = useQueryParam('code');
    return {
        error: error || 'Something went wrong. Please try again later',
        code,
    };
};
